interface LogoProps {
  className?: string;
  variant?: 'default' | 'light';
}

export default function Logo({ className = '', variant = 'default' }: LogoProps) {
  const brandClass = variant === 'light' ? 'text-white' : 'text-primary-600';
  const suffixClass = variant === 'light' ? 'text-slate-400' : 'text-slate-500';

  return (
    <div className={`flex items-baseline gap-1.5 font-semibold tracking-tight ${brandClass} ${className}`}>
      <span>Gestion Gazoil</span>
      <span className={`text-sm font-medium ${suffixClass}`}>GM</span>
    </div>
  );
}
